import { handleActions, Action } from 'redux-actions'
import {
  ClassifierType,
  IterationType,
  ObjectDetectorType,
  PretrainedModelName,
  ProjectTrainingAdvancedSettingsRequest,
} from '@tabeeb/contracts/microservices/swagger-ai-service'
import { AnnotationSource } from '../enums'

import * as rawActions from '../actions'
import { TrainingSettingsState } from '../types'

const advancedTrainingSettings: ProjectTrainingAdvancedSettingsRequest = {
  BatchSize: 2,
  ClassifierType: ClassifierType.LogisticRegression,
  ConfidenceThreshold: 0.5,
  EarlyStoppingPatience: 5,
  EarlyStoppingMinDelta: 0.0001,
  ImageEncoderLayersPercent: 7,
  LearningRate: 0.001,
  NumberOfCrossValidationFolds: 1,
  NumberOfEpochs: 0,
  ObjectDetector: ObjectDetectorType.FasterRCNN50,
  PretrainedModelName: PretrainedModelName.DinoV2Base,
  TestDataSize: 0.2,
  TextEncoderLayersPercent: 7,
}

const defaultState: TrainingSettingsState = {
  iterationType: -1,
  annotationSource: AnnotationSource.Unknown,
  settings: advancedTrainingSettings,
}

export default handleActions<TrainingSettingsState, any>(
  {
    [rawActions.setAnnotationSource.toString()](state: TrainingSettingsState, action: Action<AnnotationSource>) {
      return { ...state, annotationSource: action.payload }
    },
    [rawActions.setAdvancedTrainingSettings.toString()](
      state: TrainingSettingsState,
      action: Action<ProjectTrainingAdvancedSettingsRequest>
    ) {
      return { ...state, settings: action.payload }
    },
    [rawActions.setIterationType.toString()](state: TrainingSettingsState, action: Action<IterationType | -1>) {
      return { ...state, iterationType: action.payload }
    },
    [rawActions.setSelectedProject.toString()](state: TrainingSettingsState, action: Action<any>) {
      return defaultState
    },
    [rawActions.resetPagesForProjectTraining.toString()](state: TrainingSettingsState, action: Action<any>) {
      return defaultState
    },
  },
  defaultState
)
